import React, { createContext, useState } from 'react';

export const StoreContext = createContext();
const StoreProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  return (
    <StoreContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        user,
        setUser,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};
export default StoreProvider;
